import React from "react";
import { Modal, Button } from "react-bootstrap";

export default function NewArticleModal(props) {
  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">Article</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {/* <h4>Centered Modal</h4> */}
        <p>Article Submitted Successfully</p>
      </Modal.Body>
      <Modal.Footer>
        <Button onClick={props.onGotoHomepage}>Go to homepage</Button>
        <Button onClick={props.onHide}>Hide</Button>
      </Modal.Footer>
    </Modal>
  );
}
